module.exports = __webpack_public_path__ + "media/images/GMovies-08eb8772f4daa15d556ad93b5db7fda2.png";